import { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import darwinLoader from '../../assets/darwin-loader.json';

/** Track the user's prefers-reduced-motion setting (no framer-motion dependency). */
function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReduced(mq.matches);
    const onChange = (e: MediaQueryListEvent) => setReduced(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return reduced;
}

/**
 * The canonical Darwin loading indicator — the Darwin mark drawing itself
 * (design-system Brand/Loader). Ink stroke on light surfaces; never substitute a
 * generic spinner. Use ~20px inline beside a label, larger in panels.
 */
export function DarwinSpinner({ size = 20, className }: { size?: number; className?: string }) {
  const reduced = useReducedMotion();
  return (
    <Lottie
      animationData={darwinLoader}
      loop
      autoplay={!reduced}
      aria-hidden
      className={className}
      style={{ width: size, height: size }}
    />
  );
}
